export default "__VITE_ASSET__ac90df3a__"